// extracted by mini-css-extract-plugin
export default {"title":"i4-z","warning":"j4-z","sizeOptionsLegendText":"k4-z"};